module.exports = __webpack_public_path__ + "img/area_11_pic2.0f81c9d.jpg";